import {
  Button,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Portal,
  useDisclosure,
} from '@chakra-ui/react';
import { AddIcon, CloseIcon } from '@sketchnote/icons';
import { useState } from 'react';

import { useAgileStore } from '../../store';

function CompleteSprint({ id }: { id: string }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isSaving, setSaving] = useState(false);
  const { completeSprint } = useAgileStore();

  const handleOpen = (e) => {
    e.stopPropagation();
    onOpen();
  };

  const handleSprintComplete = () => {
    completeSprint(id);
  };

  return (
    <>
      <span className="text-sm  text-gray-500  mr-4 font-medium" onClick={handleOpen}>
        <span className="block">Complete sprint</span>
      </span>

      <Portal>
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent
            style={{
              position: 'initial',
              marginTop: '200px',
            }}
            className={` min-w-356 bg-white rounded-lg static`}
          >
            <div>
              <div className="p-24">
                <div className="flex justify-between mb-8">
                  <span className="text-primary-700 font-semibold text-xl">
                    Sprint completed? ⚡️
                  </span>
                  <button aria-label="close button" onClick={onClose}>
                    <CloseIcon className="text-gray-600 text-xs" />
                  </button>
                </div>

                <div className="w-full mb-20">
                  <label className="mb-8 block  text-sm text-gray-999 ">
                    Do you want to close this sprint?
                  </label>
                </div>

                <div className="flex justify-start  w-full">
                  <button
                    onClick={onClose}
                    className="border-blue-500 text-blue-500 border rounded-sm px-24 py-8 mr-8 w-1/2"
                  >
                    Not Yet
                  </button>
                  <button
                    className={` text-white border rounded-sm px-24 py-8  w-1/2 ${
                      isSaving ? 'bg-blue-200' : 'bg-blue-500'
                    }`}
                    onClick={handleSprintComplete}
                    disabled={isSaving}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
            <ModalCloseButton />
          </ModalContent>
        </Modal>
      </Portal>
    </>
  );
}

export default CompleteSprint;
